import React, { useEffect, useState } from "react"
import { Spin } from "antd"
import IndicatorChart from "./IndicatorChart"
import IndicatorTable from "./IndicatorTable"
import commonStrings from "../../commonStrings"
import IndicatorFilters from "./IndicatorFilters"
import { getStageParam, getTenureInfo } from "../../utilities"
import Banner from "./Banner"

const IndicatorProgressReport = ({
  rubric,
  currentSchool,
  disableOnTenureCompletion,
}) => {
  const [tableData, setTableData] = useState([])
  const [tableListing, setTableListing] = useState([])
  const [tableListingold, setTableListingold] = useState([])
  const [loading, setLoading] = useState(true)
  const [goalData, setGoalData] = useState([])
  const [graphData, setGraphData] = useState([])
  const [scatterLoading, setScatterLoading] = useState(true)
  const [stage, setStage] = useState({
    value: "commitmentStageI",
    label: "Commitment Stage I",
  })
  const handleUpdatedTableData = (updatedData) => {
    console.log(goalData)
    setGoalData(updatedData)
  }

  const fetchGraphData = (selectedStage) => {
    const today = new Date()
    const rubricDate = new Date(rubric.created_at)
    const currentTenure = getTenureInfo(today)
    const rubricTenure = getTenureInfo(rubricDate)
    const isCurrentTenure = rubricTenure.year === currentTenure.year
    console.log(selectedStage)
    setScatterLoading(true)
    const stageParam = getStageParam(stage)
    if (isCurrentTenure) {
      APIClient.get(
        `/indicator_progress/${rubric.id}${stageParam}`,
        (response) => {
          setGraphData(response)
          setScatterLoading(false)
        },
      )
    } else {
      APIClient.get(
        `/indicator_progress_old/${rubric.id}${stageParam}`,
        (response) => {
          setGraphData(response)
          setScatterLoading(false)
        },
      )
    }
  }

  useEffect(() => {
    if (!rubric || !rubric.created_at) return

    setLoading(true)
    const today = new Date()
    const rubricDate = new Date(rubric.created_at)
    const currentTenure = getTenureInfo(today)
    const rubricTenure = getTenureInfo(rubricDate)
    const isCurrentTenure = rubricTenure.year === currentTenure.year
    APIClient.get(
      `/implementation_rubrics/${rubric.id}/indicators_value?rubric_id=${rubric.id}&stage=${stage.label}`,
      (response) => {
        setTableData(response || [])
      },
    )

    const stageParam = getStageParam(stage)

    if (isCurrentTenure) {
      APIClient.get(
        `/fetch_indicators_by_rubric/${rubric.id}${stageParam}`,
        (response) => {
          setTableListing(response)
          setLoading(false)
        },
      )
    } else {
      APIClient.get(
        `/fetch_indicators_by_rubric_old/${rubric.id}${stageParam}`,
        (response) => {
          setTableListingold(response)
          setLoading(false)
        },
      )
    }
  }, [rubric.id, graphData, stage])

  const upsertGoals = (goals) => {
    APIClient.post(
      "/goals/upsert_goals",
      {
        goals: goals.map((goal) => ({
          implementation_rubric_indicator_id:
            goal.implementation_rubric_indicator_id,
          value: goal.value,
          target_completion_date: goal.target_completion_date,
        })),
      },
      (response) => {
        console.log(response)
        setLoading(true)

        const stageParam = getStageParam(stage)

        const rubricDate = new Date(rubric.created_at)
        const today = new Date()
        // const getTenureYear = (date) => {
        //   const year =
        //     date.getMonth() >= 7 ? date.getFullYear() : date.getFullYear() - 1;
        //   const start = new Date(`${year}-08-01T00:00:00`);
        //   const end = new Date(`${year + 1}-07-31T23:59:59`);
        //   return { start, end, year };
        // };

        const currentTenureYear = getTenureInfo(today)
        const isCurrentTenure = rubricDate >= currentTenureYear.start
          && rubricDate <= currentTenureYear.end

        const endpoint = isCurrentTenure
          ? `/fetch_indicators_by_rubric/${rubric.id}${stageParam}`
          : `/fetch_indicators_by_rubric_old/${rubric.id}${stageParam}`

        APIClient.get(endpoint, (response) => {
          if (isCurrentTenure) {
            setTableListing(response)
          } else {
            setTableListingold(response)
          }
          setLoading(false)
          fetchGraphData(stage)
        })
      },
    )
  }

  useEffect(() => {
    if (!rubric || !rubric.id) return
    fetchGraphData(stage)
  }, [rubric.id, stage])

  return (
    <div style={{ padding: "20px" }}>
      <div>
        <span style={{ color: "#575555", fontSize: 36, fontWeight: "700" }}>
          {commonStrings.indicatorProgressReport}
        </span>
      </div>

      <div className="filter-indicator">
        <span className="filter-indicator-title">Filter</span>
        <IndicatorFilters stage={stage} setStage={setStage} />
      </div>
      <div>
        <Banner graphData={graphData} />
      </div>
      <div className="grpah-filter">
        <IndicatorChart
          stage={stage}
          tableData={tableData}
          rubric={rubric}
          graphData={graphData}
          scatterLoading={scatterLoading}
          tableListing={tableListing}
          tableListingold={tableListingold}
          currentSchool={currentSchool}
        />
      </div>
      {loading ? (
        <div className="table-loader">
          <Spin size="large" className="spin-chart-load" />
        </div>
      ) : (
        <>
          <IndicatorTable
            tableListing={tableListing}
            tableListingold={tableListingold}
            tableData={tableData}
            upsertGoals={upsertGoals}
            graphData={graphData}
            onUpdatedTableData={handleUpdatedTableData}
            stage={stage}
            disableOnTenureCompletion={disableOnTenureCompletion}
            rubric={rubric}
          />
        </>
      )}
    </div>
  )
}

export default IndicatorProgressReport
